import { render, staticRenderFns } from "./_Bundles.vue?vue&type=template&id=5467c6c8&"
import script from "./_Bundles.vue?vue&type=script&lang=js&"
export * from "./_Bundles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports